import ACTIONS from '../../actions';
var initialState = {
  Name: undefined,
  Color: undefined,
  IconURL: undefined
};
export var manifestReducer = function manifestReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ACTIONS.MANIFEST_GET_RESOLVED:
    case ACTIONS.MANIFEST_SET:
      {
        return action.payload || state;
      }

    default:
      return state;
  }
};
export default manifestReducer;